import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import axios from 'axios';

// Login Redux States
import { LoginTypes } from './actionTypes';
import { apiError, loginSuccess, logoutUserSuccess, loginInvalid, resetPasswordSuccees, resetPasswordInvalid } from './actions';
import { getBrandSuccess } from '../../brand/actions';

//Include Both Helper File with needed methods
// import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
    postFakeLogin,
    // postJwtLogin,
    postSocialLogin,
} from '../../../helpers/fakebackend_helper';

import * as url from '../../../helpers/url_helper';
import apiFetch from '../../../fetch';
import { postJwtLogin } from '../../../helpers/login_helper';
import Swal from 'sweetalert2';
import { changeTitleBanner } from '../../actions';

function* loginUser({ payload: { user, history, networkId } }: any): any {
    const path = url.API_URL;
    const query = `query {
    login(username: "${user.email}", password: "${user.password}" ${networkId ? `,networkId: "${networkId}"` : ''} ) {
      status
      userinfo {
        id
        USUARIO_NOMBRE
        USUARIO_APELLIDO
        NETWORK_ID
        ROL_ID
        EMPRESA_ID
      }
      brand {
        name
        logo
        small_logo
        urlHome
        urlLogin
        urlFavicon
        urlLoading
        urlImgBanner
        urlLinkBanner
        theme {
            primaryColor
            secondaryColor
            primaryDarkColor
            secondaryDarkColor
            sidebarBgColor
            headerBgColor
            headerDarkBgColor
            modalHeaderBackground
            modalHeaderTitle
            modalHeaderText
            isMilestoneBackground
            isMilestoneCircle
            isMilestoneText
            modalBodyBackground
            modalBodyTitle
            modalBodyText
            modalTotalBackground
            modalTotalText
        }
      }
      permisos{
        id
        nombre
        version
        descripcion
        url_menu
        icon
        MCA_ACTIVO
        EMPRESA_ID
        IDIOMA_ID
        applicationId
        orden
        createdAt
        updatedAt
        padreId    
        identificator
        URL
        holisticsClientIdentificator
        clientSecret
        code
        generic
        excludedClientIds
        JSONHollistics
      }
      views {
        name
        groupName
        default
        items {
          label
          order
        }
      }
    }
  }`;

    const opts = {
        authRequired: false,
        body: {
            query,
            //variables: {user: userApi},
        },
        method: 'POST',
    };

    // const casing = 'underscore';
    const resp = yield call(apiFetch, path, opts);
    const responseBody = resp.body.data.login;

    if (resp.body.errors) {
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'We are facing comunications issues, working for you to fix them, Please try again later.',
        });
    } else {
        if (responseBody) {
            if (responseBody.status === 'Success') {
                const { userinfo, brand, permisos }: any = responseBody;
                localStorage.setItem('brand', JSON.stringify(brand));
                localStorage.setItem('authUser', JSON.stringify(userinfo));
                localStorage.setItem('permisos', JSON.stringify(permisos));
                yield put(getBrandSuccess(brand));
                yield put(loginSuccess(responseBody));
                history.push('/');
            } else {
                localStorage.setItem('authUser', JSON.stringify({}));
                localStorage.setItem('permisos', JSON.stringify({}));
                yield put(loginInvalid(responseBody));
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: responseBody.status === 'fail' ? 'Your user was not found!' : responseBody.status,
                });
            }
        } else {
            localStorage.setItem('authUser', JSON.stringify({}));
            //localStorage.setItem('brand', JSON.stringify({}));
            localStorage.setItem('permisos', JSON.stringify({}));
            yield put(loginInvalid(responseBody));
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: responseBody.status === 'fail' ? 'Your user was not found!' : responseBody.status,
            });
        }
    }
}

function* logoutUser({ payload: { history } }: any) {
    try {
        const authUser: any = localStorage.getItem('authUser');
        let url = '/login';
        if (authUser) {
            const obj = JSON.parse(authUser);
            url += '?nwkID=' + obj.NETWORK_ID;
        }
        localStorage.removeItem('authUser');
        localStorage.removeItem('brand');
        localStorage.removeItem('permisos');
        localStorage.removeItem("lastRequest");
        if (process.env.REACT_APP_DEFAULTAUTH === 'firebase') {
            // const response: Promise<any> = yield call(fireBaseBackend.logout);
            // yield put(logoutUserSuccess(response));
        }
        yield put(changeTitleBanner(""))
        history.push(url);
    } catch (error) {
        yield put(apiError(error));
    }
}

function* socialLogin({ payload: { data, history, type } }: any) {
    try {
        if (process.env.REACT_APP_DEFAULTAUTH === 'firebase') {
            // const fireBaseBackend = getFirebaseBackend();
            // const response: Promise<any> = yield call(
            //   fireBaseBackend.socialLoginUser,
            //   data,
            //   type
            // );
            // localStorage.setItem("authUser", JSON.stringify(response));
            // yield put(loginSuccess(response));
        } else {
            const response: Promise<any> = yield call(postSocialLogin, data);
            localStorage.setItem('authUser', JSON.stringify(response));
            yield put(loginSuccess(response));
        }
        history.push('/dashboard');
    } catch (error) {
        yield put(apiError(error));
    }
}

function* ResetPassword({ payload: { user } }: any): any {
    const path = url.API_URL;
    const query = `query {
    login(username: "${user.email}", password: "${user.password}") {
      status
    }
  }`;

    const opts = {
        authRequired: false,
        body: {
            query,
        },
        method: 'POST',
    };
    const resp = yield call(apiFetch, path, opts);
    const responseBody = resp.body.data.login;

    if (responseBody.status === 'Success') {
        yield put(resetPasswordSuccees(responseBody));
    } else {
        yield put(resetPasswordInvalid(responseBody));
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Your password is invalid',
        });
    }
}

function* authSaga() {
    yield takeEvery(LoginTypes.LOGIN_USER, loginUser);
    yield takeLatest(LoginTypes.SOCIAL_LOGIN, socialLogin);
    yield takeEvery(LoginTypes.LOGOUT_USER, logoutUser);
    yield takeEvery(LoginTypes.RESET_PASSWORD, ResetPassword);
}

export default authSaga;
